function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { createStyles, getSize, getBreakpointValue, em } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
function getPositionStyles(props, theme) {
    var padding = getSize({
        size: props.padding,
        sizes: theme.spacing
    });
    var navbarOffset = props.navbarOffsetBreakpoint ? getSize({
        size: props.navbarOffsetBreakpoint,
        sizes: theme.breakpoints
    }) : null;
    var asideOffset = props.asideOffsetBreakpoint ? getSize({
        size: props.asideOffsetBreakpoint,
        sizes: theme.breakpoints
    }) : null;
    if (!props.fixed) {
        return {
            padding: padding
        };
    }
    var navbarBreakpointValue = getBreakpointValue(navbarOffset);
    var asideBreakpointValue = getBreakpointValue(asideOffset);
    var _obj;
    return __spreadValues({
        minHeight: "100vh",
        paddingTop: "calc(var(--mantine-header-height, 0px) + ".concat(padding, ")"),
        paddingBottom: "calc(var(--mantine-footer-height, 0px) + ".concat(padding, ")"),
        paddingLeft: "calc(var(--mantine-navbar-width, 0px) + ".concat(padding, ")"),
        paddingRight: "calc(var(--mantine-aside-width, 0px) + ".concat(padding, ")")
    }, navbarBreakpointValue === asideBreakpointValue ? _define_property({}, "@media (max-width: ".concat(em(navbarBreakpointValue - 1), ")"), {
        paddingLeft: padding,
        paddingRight: padding
    }) : (_obj = {}, _define_property(_obj, "@media (max-width: ".concat(em(navbarBreakpointValue - 1), ")"), {
        paddingLeft: padding
    }), _define_property(_obj, "@media (max-width: ".concat(em(asideBreakpointValue - 1), ")"), {
        paddingRight: padding
    }), _obj));
}
var useStyles = createStyles(function(theme, props) {
    return {
        root: {
            boxSizing: "border-box"
        },
        body: {
            display: "flex",
            boxSizing: "border-box"
        },
        main: __spreadValues({
            flex: 1,
            width: "100vw",
            boxSizing: "border-box"
        }, getPositionStyles(props, theme))
    };
});
export default useStyles; //# sourceMappingURL=AppShell.styles.js.map
